import script from "./CustomCheckbox.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomCheckbox.vue?vue&type=script&lang=ts&setup=true"

import "./CustomCheckbox.vue?vue&type=style&index=0&id=c63b934c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c63b934c"]])

export default __exports__